export default "/static/common/tail-spin.svg"